import Editor from './scenario-editor/ScenarioEditor';
import './index.css'
import { onChange, setPreviousPayload, comparePayload } from './scenario-editor/utils/detect-change';
import { ErrorBoundary } from './components/error-boundary/ErrorBoundary';

const detectChange = {
  onChange,
  setPreviousPayload,
  comparePayload
};

export {
  Editor,
  detectChange,
  ErrorBoundary
};
